import { sortBy } from 'lodash';
import { RootState } from '..';

export const selectGrades = (state: RootState) =>
  sortBy(state.grades.grades, 'name');

export const selectActiveGrades = (state: RootState) =>
  sortBy(
    state.grades.grades.filter(x => x.active),
    'name'
  );

export const selectActiveCorrectedGrades = (state: RootState) =>
  sortBy(
    state.grades.grades.filter(g => g.corrected && g.active),
    'name'
  );

export const selectGradeErrors = (state: RootState) => state.grades.errors;
